<template>
	<div>
		<wysiwyg v-model="content"  :options="options" />
		<input type="hidden" :name="name" v-model="content">
	</div>
</template>

<script>
	export default {
		props: [
		'name',
		'value',
		'post_id',
		],
		data() {
			return {
				content: '',
				options: {},
				csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
			}
		},
		mounted: function() {
			if( this.value  ){
				this.content = this.value;
			}
			this.options =  { 
				hideModules: {
					"underline": true,
					"link": true,
					"code": true,
				},
				image: {
					uploadURL: "/endpoint/upload",
					dropzoneOptions: {
						maxFilesize: 1, 
						maxFiles: 5,
						acceptedFiles: 'image/*',
						method: 'post',
						params: {
							'_token': this.csrf,
							'post_id': this.post_id
						}
					}
				},
				forcePlainTextOnPaste: true
			}
		}
	}
</script>





// WEBPACK FOOTER //
// resources/js/components/wysiwyg.vue